/* eslint-disable react/no-unused-state */
/* eslint-disable jsx-a11y/anchor-has-content */
import React from 'react';
import PropTypes from 'prop-types';
import QueryString from 'query-string';

import forwardRefWithTranslation from '@/common/forwardRefWithTranslation';
import LanguagePicker from './LanguagePicker';
import Policies from './Policies';

const { app, headoffice } = Mobi2Go;
const ui_map = {
    web: 'mobile',
    mobile: 'web',
    'web-embed': 'mobile-embed',
    'mobile-embed': 'web-embed',
};
const getOppositeUiUrl = () => {
    const { protocol, host, pathname, search, hash } = window.location;
    const { ui_name } = Mobi2Go.app;
    const query_string = QueryString.stringify({
        ...QueryString.parse(search),
        ui: ui_map[ui_name] || ui_name,
        no_redirect: null,
    });

    return `${protocol}//${host}${pathname}?${query_string}${hash}`;
};

class OrderFooter extends React.Component {
    state = {
        hash: window.location.hash,
    };

    componentDidMount() {
        window.addEventListener('hashchange', this.updateHashState);
    }

    componentWillUnmount() {
        window.removeEventListener('hashchange', this.updateHashState);
    }

    updateHashState = () => this.setState({ hash: window.location.hash });

    render() {
        const { t, className } = this.props;
        const is_mobile_ui = app.isMobileUI();

        return (
            <div className={className}>
                <div className="m2g-order-footer-ui-switch">
                    <a data-ui-switch href={getOppositeUiUrl()}>
                        <span
                            className={`m2g-icon m2g-icon--${
                                is_mobile_ui ? 'desktop' : 'mobile'
                            } m2g-order-footer-ui-icon`}
                        />
                        &nbsp;
                        {is_mobile_ui ? t('desktop_site') : t('mobile_site')}
                    </a>
                </div>

                <LanguagePicker className="m2g-order-footer-language-picker" />

                {is_mobile_ui && (
                    <ul className="m2g-order-footer-social-links">
                        {headoffice.facebook && (
                            <li className="m2g-order-footer-social-link">
                                <a
                                    href={`https://facebook.com/${headoffice.facebook}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="m2g-icon m2g-icon--facebook"
                                />
                            </li>
                        )}
                        {headoffice.twitter && (
                            <li className="m2g-order-footer-social-link">
                                <a
                                    href={`https://twitter.com/${headoffice.twitter}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="m2g-icon m2g-icon--twitter"
                                />
                            </li>
                        )}

                        {headoffice.instagram && (
                            <li className="m2g-order-footer-social-link">
                                <a
                                    href={`https://instagram.com/${headoffice.instagram}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="m2g-icon m2g-icon--instagram"
                                />
                            </li>
                        )}

                        {headoffice.tripadvisor && (
                            <li className="m2g-order-footer-social-link">
                                <a
                                    href={`https://tripadvisor.com/${headoffice.tripadvisor}`}
                                    target="_blank"
                                    className="m2g-icon m2g-icon--tripadvisor"
                                />
                            </li>
                        )}
                    </ul>
                )}

                <Policies classPrefix="m2g-order-footer-links" t={t} />

                {headoffice.show_mobi2go_logos && (
                    <div className="m2g-order-footer-logo">
                        <a
                            href="https://www.mobihq.com/?utm_campaign=store_front"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <svg
                                id="Layer_1"
                                height="50"
                                width="100"
                                data-name="Layer 1"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 130 60"
                            >
                                <defs />
                                <path
                                    className="cls-1"
                                    d="M33.1,8.47h2.81a2.67,2.67,0,0,1,1.24.27,2,2,0,0,1,.81.77,2.28,2.28,0,0,1,.28,1.13A2.34,2.34,0,0,1,38,11.77a2,2,0,0,1-.81.76,2.55,2.55,0,0,1-1.24.28H34.43v2.66H33.1Zm2.75,3.23a1.06,1.06,0,0,0,.82-.3,1.11,1.11,0,0,0,.28-.76,1.09,1.09,0,0,0-.28-.76,1.06,1.06,0,0,0-.82-.3H34.43V11.7Z"
                                />
                                <path
                                    className="cls-1"
                                    d="M40.83,15.08a3.37,3.37,0,0,1-1.26-1.28A3.61,3.61,0,0,1,39.11,12a3.67,3.67,0,0,1,.46-1.84,3.44,3.44,0,0,1,1.26-1.28,3.59,3.59,0,0,1,1.82-.46,3.56,3.56,0,0,1,1.81.46,3.44,3.44,0,0,1,1.26,1.28A3.67,3.67,0,0,1,46.18,12a3.61,3.61,0,0,1-.46,1.83,3.37,3.37,0,0,1-1.26,1.28,3.56,3.56,0,0,1-1.81.47A3.6,3.6,0,0,1,40.83,15.08Zm-.1-1.87a2.2,2.2,0,0,0,.78.87,2.14,2.14,0,0,0,3.05-.87A2.67,2.67,0,0,0,44.85,12a2.71,2.71,0,0,0-.29-1.25,2.17,2.17,0,0,0-3.05-.88,2.16,2.16,0,0,0-.78.88A2.71,2.71,0,0,0,40.44,12,2.67,2.67,0,0,0,40.73,13.21Z"
                                />
                                <path
                                    className="cls-1"
                                    d="M46.73,8.47h1.34l1.45,5,1.52-5h1.13l1.53,5,1.46-5h1.33l-2.09,7H53.1l-1.49-5-1.49,5H48.83Z"
                                />
                                <path
                                    className="cls-1"
                                    d="M57.56,8.47h4.66V9.61H58.88v1.7h2.68v1.14H58.88v1.87h3.45v1.15H57.56Z"
                                />
                                <path
                                    className="cls-1"
                                    d="M63.68,8.47h2.86a2.67,2.67,0,0,1,1.24.27,2.05,2.05,0,0,1,.81.76,2.31,2.31,0,0,1,.28,1.13,1.61,1.61,0,0,1-.94,1.51,1.64,1.64,0,0,1,.57.6,2.16,2.16,0,0,1,.26.86l.17,1.87H67.62l-.17-1.72a1,1,0,0,0-.29-.66.9.9,0,0,0-.65-.25H65v2.63H63.68Zm2.8,3.23a1,1,0,0,0,.82-.31,1.11,1.11,0,0,0,.28-.76,1,1,0,0,0-1.1-1.05H65V11.7Z"
                                />
                                <path
                                    className="cls-1"
                                    d="M70.51,8.47h4.66V9.61H71.83v1.7h2.68v1.14H71.83v1.87h3.45v1.15H70.51Z"
                                />
                                <path
                                    className="cls-1"
                                    d="M76.63,8.47H78.9a4.14,4.14,0,0,1,1.81.39A3,3,0,0,1,82,10.05,3.6,3.6,0,0,1,82.49,12,3.65,3.65,0,0,1,82,13.89a3.08,3.08,0,0,1-1.3,1.18,4,4,0,0,1-1.81.4H76.63Zm2.16,5.85a2.51,2.51,0,0,0,1.68-.57A2.21,2.21,0,0,0,81.15,12a2.24,2.24,0,0,0-.68-1.79,2.51,2.51,0,0,0-1.68-.57H78v4.71Z"
                                />
                                <path
                                    className="cls-1"
                                    d="M85.55,8.47h2.71a2.46,2.46,0,0,1,1.58.47,1.58,1.58,0,0,1,.61,1.33,1.45,1.45,0,0,1-.25.83,1.73,1.73,0,0,1-.6.55,1.81,1.81,0,0,1,.87.64,1.79,1.79,0,0,1,.33,1.11,1.86,1.86,0,0,1-.67,1.52,2.71,2.71,0,0,1-1.77.55H85.55Zm2.62,2.74A1.15,1.15,0,0,0,89,11a.74.74,0,0,0,.27-.62A.76.76,0,0,0,89,9.74a1.29,1.29,0,0,0-.8-.21h-1.3v1.68Zm0,3.11c.87,0,1.31-.33,1.31-1a.89.89,0,0,0-.33-.75,1.55,1.55,0,0,0-1-.25H86.85v2Z"
                                />
                                <path
                                    className="cls-1"
                                    d="M93.55,12.56,91.14,8.47h1.43l1.64,2.86,1.65-2.86h1.42l-2.41,4.09v2.91H93.55Z"
                                />
                                <path
                                    className="cls-1"
                                    d="M98.06,23.8a20.69,20.69,0,0,1,4.37.43,10.33,10.33,0,0,1,3.49,1.39,6.81,6.81,0,0,1,2.3,2.47,7.59,7.59,0,0,1,.84,3.71,6.68,6.68,0,0,1-.34,2.15,6.57,6.57,0,0,1-1,1.84,6.33,6.33,0,0,1-1.43,1.4,6,6,0,0,1-1.8.87,7.49,7.49,0,0,1,2,.92,7.11,7.11,0,0,1,1.66,1.48,7,7,0,0,1,1.14,2,6.6,6.6,0,0,1,.42,2.37,8.47,8.47,0,0,1-.78,3.78,6.84,6.84,0,0,1-2.22,2.61,10,10,0,0,1-3.46,1.51,19.2,19.2,0,0,1-4.54.49H84.14V23.8Zm-9.18,4.45v7.92h9a19.54,19.54,0,0,0,2.35-.14,6.07,6.07,0,0,0,2-.56,3.36,3.36,0,0,0,1.36-1.2,3.94,3.94,0,0,0,.5-2.11,3.76,3.76,0,0,0-.5-2,3.37,3.37,0,0,0-1.37-1.19,6.38,6.38,0,0,0-2-.54,19.88,19.88,0,0,0-2.37-.14Zm0,12.35v8.14h9.65a16.69,16.69,0,0,0,2.55-.17,5.58,5.58,0,0,0,2-.62,3.16,3.16,0,0,0,1.27-1.24,4.25,4.25,0,0,0,.45-2.08,4.07,4.07,0,0,0-.45-2A3.2,3.2,0,0,0,103,41.37a6.27,6.27,0,0,0-2-.61,18.15,18.15,0,0,0-2.55-.16Z"
                                />
                                <path
                                    className="cls-1"
                                    d="M76.21,32.41a14.19,14.19,0,0,0-8-8,14.92,14.92,0,0,0-2.3-.7L64.16,28a10,10,0,0,1,2,.58,9.65,9.65,0,0,1,3.3,2.18,10.28,10.28,0,0,1,2.17,3.38,12.34,12.34,0,0,1,0,8.69,10.18,10.18,0,0,1-2.17,3.38,9.82,9.82,0,0,1-3.3,2.19,10.67,10.67,0,0,1-2,.57l1.71,4.31a14.92,14.92,0,0,0,2.3-.7,14.19,14.19,0,0,0,8-8,16.95,16.95,0,0,0,0-12.17"
                                />
                                <path
                                    className="cls-1"
                                    d="M59,49a10.67,10.67,0,0,1-1.95-.57,9.82,9.82,0,0,1-3.3-2.19,10.18,10.18,0,0,1-2.17-3.38,12.34,12.34,0,0,1,0-8.69,10.28,10.28,0,0,1,2.17-3.38,9.79,9.79,0,0,1,3.3-2.18A10,10,0,0,1,59,28L57.33,23.7a14.92,14.92,0,0,0-2.3.7,14.19,14.19,0,0,0-8,8,17,17,0,0,0,0,12.18,14.21,14.21,0,0,0,8,8,14.92,14.92,0,0,0,2.3.7Z"
                                />
                                <polygon
                                    className="cls-1"
                                    points="31.76 23.8 23.4 43.22 15.04 23.8 7.74 23.8 7.74 53.19 12.48 53.19 12.48 29.24 20.88 48.74 25.93 48.74 34.33 29.01 34.33 53.19 39.06 53.19 39.06 23.8 31.76 23.8"
                                />
                                <rect
                                    className="cls-1"
                                    x="117.52"
                                    y="23.8"
                                    width="4.75"
                                    height="29.39"
                                />
                            </svg>
                        </a>
                    </div>
                )}
            </div>
        );
    }
}

OrderFooter.propTypes = {
    t: PropTypes.func.isRequired,
    className: PropTypes.string,
};

OrderFooter.defaultProps = {
    className: '',
};

export default forwardRefWithTranslation('order.footer')(OrderFooter);
